import React, { useEffect } from 'react';
import './AlertModal.css';

const AlertModal = ({ title, message, onClose }) => {
  // Close on Escape key
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  // Determine icon and color based on message content
  const getType = () => {
    const text = (title + message).toLowerCase();
    if (text.includes('success') || text.includes('🎉') || text.includes('✅')) return 'success';
    if (text.includes('error') || text.includes('fail') || text.includes('invalid') || text.includes('wrong')) return 'error';
    if (text.includes('warn') || text.includes('expired') || text.includes('permission')) return 'warning';
    return 'info';
  };

  const type = getType();

  const icons = {
    success: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="9 12 11 14 15 10" />
      </svg>
    ),
    error: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
      </svg>
    ),
    warning: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
    ),
    info: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
    ),
  };

  // Clean up emoji from displayed message
  const cleanMessage = message.replace(/[🎉✅]/g, '').trim();

  return (
    <div className="alert-modal-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="alert-title">
      <div className="alert-modal" onClick={(e) => e.stopPropagation()}>
        <div className={`alert-modal-icon alert-modal-icon--${type}`}>
          {icons[type]}
        </div>

        {title ? (
          <h3 className="alert-modal-title" id="alert-title">{title}</h3>
        ) : (
          <h3 className="alert-modal-title" id="alert-title">
            {type === 'success' ? 'Success' : type === 'error' ? 'Error' : type === 'warning' ? 'Warning' : 'Notice'}
          </h3>
        )}

        <p className="alert-modal-message">{cleanMessage}</p>

        <button className="alert-modal-btn" onClick={onClose} autoFocus>
          OK
        </button>
      </div>
    </div>
  );
};

export default AlertModal;
